module.exports = __webpack_public_path__ + "static/media/scca-runoffs-2020@2x.db0433bc.png";


//////////////////
// WEBPACK FOOTER
// ./html/assets/images/scca-runoffs-2020@2x.png
// module id = 1151
// module chunks = 0